import { CUSTOMER_CONTACT_TYPE } from "../constants/customer-contact.constants";
import { CUSTOMERS_GROUP_TYPE, CustomersGroupType } from "../customers.routes";
import { CustomerContact } from "../entities/customer-contact.entity";

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const getCleanName = (name?: string) =>
  (name || "").trim().toLowerCase();

export const getNameInitials = (name?: string) => {
  const clean = (name || "").trim();
  if (!clean) return "";
  return clean
    .split(/\s+/)
    .map((part) => part[0] || "")
    .join("")
    .slice(0, 2)
    .toUpperCase();
};

export const getPhoneWithCountryCode = (contact?: CustomerContact) => {
  const prefix = contact?.prefixPhone?.trim();
  const phone = contact?.phone?.trim();
  if (!prefix || !phone) return "";
  return `${prefix}${phone}`;
};

export const isFavoriteContact = (contact: CustomerContact) =>
  !!contact.data?.favorite;

export const isOfferContact = (contact: CustomerContact) =>
  !!contact.data?.isOfferAddon;

export const isPersonContact = (contact?: CustomerContact) =>
  (contact?.data?.type || CUSTOMER_CONTACT_TYPE.PERSON) ===
  CUSTOMER_CONTACT_TYPE.PERSON;

export const isValidEmail = (email?: string) => {
  const value = email?.trim();
  if (!value) return true;
  return EMAIL_REGEX.test(value);
};

export const isValidPhone = (contact?: CustomerContact) =>
  !!getPhoneWithCountryCode(contact);

export const sortContactsByName = (contacts: CustomerContact[]) =>
  [...contacts].sort((a, b) =>
    getCleanName(a.name).localeCompare(getCleanName(b.name), undefined, {
      sensitivity: "base",
    })
  );

export const shouldShowLetterHeader = (
  contacts: CustomerContact[],
  index: number
) => {
  if (index === 0) return true;
  const current = getCleanName(contacts[index]?.name).charAt(0);
  const previous = getCleanName(contacts[index - 1]?.name).charAt(0);
  return current !== previous;
};

export const filterContactsByGroup = (
  contacts: CustomerContact[],
  groupType?: CustomersGroupType
) => {
  if (groupType === CUSTOMERS_GROUP_TYPE.FAVORITES) {
    return contacts.filter(isFavoriteContact);
  }
  if (groupType === CUSTOMERS_GROUP_TYPE.OFFERS) {
    return contacts.filter(isOfferContact);
  }
  return contacts;
};

export const isContactFormValid = (contact?: CustomerContact) => {
  if (!contact) return false;
  const name = contact.name?.trim();
  const prefix = contact.prefixPhone?.trim();
  const phone = contact.phone?.trim();
  const isBusiness =
    contact.data?.type === CUSTOMER_CONTACT_TYPE.BUSINESS;
  const businessValid = !isBusiness
    ? true
    : !!contact.data?.administratorName?.trim() &&
      !!contact.data?.businessCode?.trim() &&
      !!contact.data?.businessAddress?.trim();

  return !!name && !!prefix && !!phone && isValidEmail(contact.email) && businessValid;
};
